import { GzHorizontalStackedBarChartWebComponent } from './component/GzHorizontalStackedBarChartWebComponent';

export { GzHorizontalStackedBarChartWebComponent };
